export default __webpack_public_path__ + "static/media/milesDavis.f5213088.jpg";